<template>
	<div class="initial-quote-modal">
		<header class="modal-header" :class="[showing, (showing == 'initial') ? 'initial' : 'not-initial']">
			<div class="modal-header-title" v-if="showing == 'initial'">
				<h2>
					Get a Quote
				</h2>
			</div>
			<div class="modal-content">
				<p class="text-white text-sm" v-if="showing == 'initial'">
					Enter the following details to receive an instant quote
				</p>
				<div v-else>
					<div class="flex md:bg-teal-600 rounded-md">
						<div class="flex-1  text-center text-teal-50 md:p-2 p-1 border-r border-teal-700"
							id="monthly-price">
							<div class="">
								<h5 class="price-header">Monthly</h5>
								<p class="font-semibold text-2xl">{{ monthlyPrice | currency }}</p>
							</div>
						</div>
						<div class="flex-1 text-center text-teal-50 md:p-2 p-1" id="yearly-price">
							<div class="">
								<h5 class="price-header">Annually</h5>
								<p class="font-semibold text-2xl">{{ yearlyPrice | currency }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>

		<div id="first-quote-container" v-if="showing == 'initial'">



			<div class="mx-auto max-w-sm px-4 sm:px-0 pt-6">


				<tw-alert class="mt-4" :show="initialError" type="error">{{ initialError }}</tw-alert>

				<tw-alert class="mt-4" :show="showErrors && displayErrors.length > 0" size="xs" type="error">
					<div v-for="e in displayErrors">{{ e }}</div>
				</tw-alert>

				<div class="inputs mt-6 mb-4">
					<p class="bike-value-label mb-1">
						<span class="text-base">Bike value <button class="tooltip-el"
								v-tooltip="'Please select a bike value up to a maximum of £10,000'">?</button></span>

						<a class="text-sm float-right link no-underline" v-if="numBikes < maxBikes" @click="addBike">
							Add another bike?
						</a>
					</p>

					<template v-for="index in maxBikes">
						<div class="fade opacity-0" :class="[index <= numBikes ? 'opacity-100 mb-2' : '']">
							<div class="items-center" :class="[numBikes > 1 ? 'flex' : '']" v-if="index <= numBikes">
								<div class="w-1/6 text-center number-container transition-all duration-100 ease-in-out"
									:class="[(showErrors && errors['bikes'][index]) ? 'mb-4' : '']" v-if="numBikes > 1">
									<span class="number mx-auto"> {{ index }} </span>
								</div>
								<div :class="[numBikes > 1 ? 'w-4/6' : '']">
									<component is="tw-input" name="Bike Value" addon="£" :inputId="'bikes'"
										placeholder="Estimated value" :showError='showErrors' :showErrorText="false"
										:minVal="100" :maxVal="10000" :label="false" @updated="updatedInput($event, index)"
										:val="(form.bikes[index]) ? form.bikes[index] : ''" :auto-complete='false'
										input-type="number"></component>
								</div>
								<div class="w-1/6 text-center px-1 transition-all duration-100 ease-in-out"
									:class="[(showErrors && errors['bikes'][index]) ? 'mb-4' : '']"
									v-if="numBikes > 1 && index == numBikes">
									<tw-button variant="secondary" @clicked="deleteBike(index)">
										<i class="far fa-trash"></i>
									</tw-button>
								</div>
							</div>
						</div>
					</template>

					<tw-input name="Postcode" icon="location" placeholder="Your postcode" type="postcode" class="mt-4"
						:showError='showErrors' :showErrorText='false' @updated="updatedInput"
						:val="(form.postcode) ? form.postcode : ''" :auto-complete='false' @event:enter='makeQuote'>
					</tw-input>

					<tw-button full :busy="isLoading" size="lg" @clicked="makeQuote" class="mt-10">
						Next <i class="far fa-chevron-right ml-2"></i>
					</tw-button>



					<div
						class="border-t border-gray-200 flex md:flex-col flex-col items-center gap-2 mt-10 py-4 justify-center">

						<div class="flex-1">
							<img src="/images/awards-2024-white.png" class="h-20" alt="2024 Award">
						</div>
						<div class="flex-1">
							<img src="/images/feefo.png" class="h-20" alt="Feefo Award">
						</div>
					</div>


				</div>
			</div>
		</div>
		<div id="prices-container" v-else-if="showing == 'prices'">


			<introductory-discount-applied :quote="quote"></introductory-discount-applied>


			<tw-alert class="mt-4" :show="(productError) ? true : false" type="error">{{ productError }}</tw-alert>

			<div class="quote-options mt-2">
				<div id="sub-header">
					<div class="progress">
						<progress-bar :progress="progress"></progress-bar>
					</div>
				</div>
				<div class="flex flex-wrap mt-4">
					<transition mode="out-in" name="fade">
						<div class="slide list-item" v-for="(product, productKey) in quote.products"
							:key="product.meta.name" v-if="product.meta.slug == currSlide">
							<keep-alive>
								<div class="mx-3">
									<div class="relative">
										<div class="absolute inset-0 flex items-center" aria-hidden="true">
											<div class="w-full border-t border-gray-300"></div>
										</div>
										<div class="relative flex justify-center">
											<h4
												class="flex-shrink-0 bg-white px-2 text-base leading-5 tracking-wider font-medium uppercase ">
												<p class="inline-block ">{{ product.meta.name }}</p>
												<div class="inline-block" v-if="product.meta.description">
													<button class="tooltip-el" v-tooltip="product.meta.description">
														?
													</button>
												</div>
												</p>
											</h4>
										</div>
									</div>

									<div>
										<tw-toggle-group :name="product.meta.slug" :options="product.options"
											:selected="form.products[product.meta.slug].name" @updated="toggleUpdate">
											<template v-for="(opt, index) in product.options" :slot="'additional_'+index">
												<p class="option-value">{{ opt.value | currency }}</p>
											</template>
										</tw-toggle-group>
									</div>
								</div>
							</keep-alive>
						</div>
					</transition>

					<div class="flex justify-between w-full mb-4 px-2 gap-3 pt-24"
						:class="{ 'last-slide': currSlide == slides[slides.length - 1] }">
						<div>

							<tw-button full variant="secondary " @clicked="prevSlide" v-if="currSlide !== slides[0]"
								class="back-btn">
								<span class="sm:mx-16 mx-10">
									Back
								</span>
							</tw-button>
							<tw-button full variant="secondary " @clicked="show = 'initial'" class="back-btn" v-else>
								<span class="sm:mx-16 mx-10">
									Back
								</span>
							</tw-button>
						</div>

						<div>
							<tw-button full @clicked="nextSlide">
								<span class="sm:mx-16 mx-10">
									Next
								</span>
							</tw-button>
						</div>
					</div>

				</div>
			</div>

			<div id="quote-options" class="flex flex-wrap" v-if="false">

				<div class="option w-1/2" v-for="option in options">
					<h2>{{ option.name }}</h2>

					<div class="option-value" v-for="option_value in option.options">
						<p>{{ option_value.name }}</p>
						<p>{{ option_value.value }}</p>
					</div>
				</div>
			</div>
		</div>
		<div id="account-container" v-else-if="showing == 'social'">
			<div class="back-btn-container" v-if="accountBack">
				<a class="back-btn" @click="show = 'prices'">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
						<path d="M10 13h8V7h-8V2l-8 8 8 8v-5z" />
					</svg>
					<span>Back</span>
				</a>
			</div>
			<initial-account @changed="accountBack = false" @loggedIn="loginRedirect"
				@social="socialCheck"></initial-account>
		</div>
		<loading :show="isLoading"></loading>
	</div>
</template>

<script>
import progressBar from '../../inc/progress.vue';
import initialAccount from '../initial/account.vue';
import IntroductoryDiscountApplied from '../../inc/IntroductoryDiscountApplied';

export default {
	name: 'quote.initial.main',
	components: {
		progressBar,
		initialAccount,
		IntroductoryDiscountApplied
	},
	data() {
		return {
			form: {
				bikes: {},
				postcode: false,
				products: {},
			},
			errors: {
				bikes: {},
				postcode: false,
			},
			initialError: false,
			productError: false,
			quote: {
				id: false,
				bikes: false,
				products: false,
			},
			defaultSelectors: [
				'no',
			],
			numBikes: 1,
			maxBikes: 5,
			showErrors: false,
			show: 'inital',
			isLoading: false,
			currSlide: false,
			register: {},
			registerErrors: false,
			login: {},
			reset: {},
			resetErrors: false,
			resetFeedback: false,
			disabledLoading: false,
			accountBack: true,
		}
	},
	watch: {
		slides: function (val) {
			this.currSlide = this.slides[0];
		},
		showing: function (val) {
			const self = this;

			if (val == 'initial') {
				self.$eventBus.$emit('resize-modal', {
					'ref': 'get-quote',
					'size': 'lg'
				});
			}

			// resize modal depending on what slide they're on
			if (val == 'prices') {
				self.$eventBus.$emit('resize-modal', {
					'ref': 'get-quote',
					'size': 'xl3'
				});
			}

			if (val == 'social') {
				self.$eventBus.$emit('resize-modal', {
					'ref': 'get-quote',
					'size': 'lg'
				});
			}

			if (val == 'register') {
				self.$eventBus.$emit('resize-modal', {
					'ref': 'get-quote',
					'size': 'lg'
				});
			}
		},
		quote: {
			deep: true,

			handler(newValue) {
				this.$emit('prices', newValue);
			}
		},
	},
	mounted() {


	},
	computed: {
		hasErrors() {
			var returnVal = false;

			// loop through errors and check if any exist
			let e = this.errors;
			Object.keys(e).forEach(function (key) {
				if (typeof e[key] === 'object') {
					Object.keys(e[key]).forEach(function (key2) {
						if (e[key][key2] != false) {
							returnVal = true;
						}
					});
				} else {
					if (e[key] != false) {
						returnVal = true;
					}
				}
			});

			return returnVal;
		},
		showing() {
			// return 'forgotPassword';

			if (this.show == 'social') {
				return 'social';
			}

			if (this.show == 'signIn') {
				return 'signIn';
			}

			if (this.show == 'resetPassword') {
				return 'resetPassword';
			}

			if (this.show == 'register') {
				return 'register';
			}

			if (this.show == 'prices' && this.quote && this.form.bikes[1] > 0 && this.form.postcode) {
				return 'prices';
			}

			return 'initial';
		},
		monthlyPrice() {
			return (this.yearlyPrice / 12);
		},
		yearlyPrice() {
			var price = 0;

			if (this.quote) {
				price = this.quote.client_premium;
			}

			return price;
		},
		slides() {
			var slideArr = [];

			let products = this.quote.products;
			Object.keys(products).forEach(function (key) {

				// push option with all options
				slideArr.push(products[key].meta.slug);
			});

			return slideArr;
		},
		slideIndex() {
			return this.slides.indexOf(this.currSlide);
		},
		progress() {
			let i = (this.slideIndex + 1);

			return (i / this.slides.length) * 100;
		},
		displayErrors() {
			let arr = [];

			let b = this.errors.bikes;
			let hasBikeError = false;
			Object.keys(b).forEach(function (key) {

				if (b[key] !== '' && !hasBikeError) {
					hasBikeError = true;
					// push option with all options
					arr.push(b[key]);
				}
			});

			if (this.errors.postcode && this.errors.postcode != '') {
				arr.push(this.errors.postcode);
			}

			return arr;
		}
	},
	methods: {
		updatedInput(e, index = null) {
			const self = this;

			// store form data/errors for each input
			Object.keys(e).forEach(function (key) {
				// if index is provided, store against it, otherwise assign to key directly
				if (index != null) {
					Vue.set(self.form[key], index, e[key]['value']);
					Vue.set(self.errors[key], index, e[key]['errors']);
				} else {
					self.form[key] = e[key]['value'];
					self.errors[key] = e[key]['errors'];

				}
			});
		},
		addBike() {
			this.numBikes++;
		},
		deleteBike(index) {
			this.numBikes--;

			// delete error/form records
			Vue.delete(this.errors['bikes'], index);
			Vue.delete(this.form['bikes'], index);
		},
		makeQuote() {

			if (this.hasErrors) {
				this.showErrors = true;
			} else {
				// show any error messages for each input
				this.showErrors = false;

				// show loading gif
				this.isLoading = true;

				// make call to create quote/get prices
				const self = this;
				axios.post("quote", this.form)
					.then((resp) => {
						if (resp.data) {
							if (resp.data.success) {
								// store quote details
								self.quote = resp.data.quote;

								// filter products - will stop one option products from showing (but still added to form data)
								self.filterProducts();

								// change what should be shown
								self.show = 'prices';

								// clear any existing errors 
								self.initialError = false;
							} else {
								self.initialError = 'Error - Unable to make quote';
							}
						}

						// stop loading gif
						self.isLoading = false;
					})
					.catch((errors) => {
						// stop loading gif
						self.isLoading = false;
						self.initialError = 'Error - An error occurred. Please try again.';

						if (errors.response.data.hasOwnProperty('message')) {
							self.initialError = errors.response.data.message;
							if (self.initialError === '') {
								self.initialError = 'There has been a problem with your request';
							}
						}
					})
			}
		},
		filterProducts() {
			const self = this;

			// get quote products
			let p = this.quote.products.products;

			// only show products that have more than one option - automatically push one optioned products to form array
			var productArr = [];
			if (p) {
				Object.keys(p).forEach(function (key) {
					var product = p[key];

					if (product.options.length > 1) {
						// store preselected values in form.products
						var selected = product.options.filter(p => p.is_selected == 1);
						if (selected.length == 1) {
							selected = selected[0];

							let newVals = {
								name: selected.name,
								value: selected.premium_id,
							};
							self.$set(self.form.products, product.meta.slug, newVals);
						}

						productArr.push(product);
					} else {
						let newVals = {
							name: product.options[0]['name'],
							value: product.options[0]['premium_id'],
						};

						self.$set(self.form.products, product.meta.slug, newVals);
					}
				});

				// overwrite products
				self.quote.products = productArr;
			}
		},
		nextSlide() {
			const self = this;

			// next slide index
			let nextIndex = (self.slideIndex + 1);
			if (self.slides[nextIndex]) {
				self.currSlide = self.slides[nextIndex];
			} else {

				this.analytics();
				this.isLoading = true;

				setTimeout(() => {
					self.loginRedirect();
				}, 200);
				// if next slide doesn't exist, assume at end of addons and move onto social stage
				// self.show = 'social';
			}
		},
		prevSlide() {
			// previous slide index
			let prevIndex = (this.slideIndex - 1);

			this.currSlide = this.slides[prevIndex];
		},
		toggleUpdate(e) {
			const self = this;

			// Start loading
			self.isLoading = true;

			// Update products
			let productArr = {
				'name': e["name"],
				'value': e["premium_id"],
			};
			this.$set(this.form.products, e["option"], productArr);

			// get selected slides values
			var selectedSlide = self.form.products[self.currSlide];

			// premium id is value of selected option
			var sendData = {
				premium_id: selectedSlide.value
			};

			// send selection to core
			axios.post('quote/products', sendData)
				.then((resp) => {
					if (resp.data) {
						if (resp.data) {
							// update premium
							self.quote.client_premium = resp.data.client_premium;

							// stop loading
							self.isLoading = false;
						} else {
							self.productError = 'Error - Unable to generate quote';
						}
					}
				})
				.catch((error) => {
					// stop loading
					self.isLoading = false;

					self.productError = 'Error - ' + error;
				})
		},
		getQuote() {
			const self = this;

			if (this.quote.quote_id) {
				axios.get('quote/getQuote')
					.then((resp) => {
						if (resp.data) {
							if (resp.data.quote && resp.data.quote.client) {
								self.quote.client = resp.data.quote.client;
							}
						}
					})
					.catch(error => {

					});
			}
		},
		loginRedirect() {
			const self = this;

			// Ensure Quote is assigned to Client
			// axios.post('quote/assignClient')
			// 	 .then((resp) => {
			// 	 	if(resp.data) {
			// 	 		if(resp.data.success) {
			window.location.href = self.baseUrl + '/quote/';
			// 		}
			// 	}
			// })
			// .catch(error => {
			// });
		},
		socialCheck(e) {
			this.getQuote();

			// stop interval if popup is closed manually
			if (e.popup.closed) {
				clearInterval(e.check);
			}

			if (this.quote.client) {
				e.popup.close();

				// relocate to quote page
				this.loginRedirect();
			}
		},
		analytics() {

			let quote = this.quote;

			(function (w, d, quote) {
				var id = "vpr-capture", n = "script"

				if (!d.getElementById(id)) {
					vpr = w.vpr || function () { (w.vpr.a = w.vpr.a || []).push(arguments); };
					var e = d.createElement(n); e.id = id; e.async = 1
					e.src = 'https://cdn.veritonic.com/static/vpr-eu.min.js'
					var s = d.getElementsByTagName(n)[0]
					s.parentNode.insertBefore(e, s)
				}

				vpr("veritonic_id", "pgbx2ZvU"); // this is the Veritonic ID associated with your brand
				vpr('addtocart', { // this is the action you want to track
					// update your product details below for each product you want to track with this action
					value: quote.client_premium,
					currency: 'GBP',
					quantity: 1,
					product_id: quote.reference,
					product_name: 'Cycle insurance',
					product_type: 'insurance',
					product_vendor: 'ProtectMyBike',
					variant_id: null,
					variant_name: null
				});

			})(window, document, quote);


		}
	}
}
</script>